import React from 'react';

import './style.sass';

type Props = {
    className?: string,
    isActive: boolean,
    onClickBtn: () => void,
};

export const MenuButton = ({ isActive, onClickBtn, className }: Props) => {
    return (
        <div
            className={`menu-btn ${isActive ? 'menu-btn--cross' : ''} ${className ? className : ''}`}
            onClick={onClickBtn}
        >
            <div className="menu-btn__lines">
                <div className="menu-btn__line"></div>
                <div className="menu-btn__line"></div>
            </div>
        </div>
    );
};
